module.exports = __webpack_public_path__ + "static/media/information.bbde085f.svg";